// This file imports and wraps RichTextEditorPage for project editing
// It sets the context to project mode automatically

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RichTextEditorPage from './RichTextEditorPage';

export default function ProjectEditorPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Set project mode in localStorage so RichTextEditorPage knows we're editing a project
    localStorage.setItem('editor_mode', 'project');
    localStorage.setItem('editor_project_id', projectId || 'new');
    
    // Clear any blog mode data
    localStorage.removeItem('blog_editor_mode');
    localStorage.removeItem('blog_editor_data');
    localStorage.removeItem('blog_editor_backup');
  }, [projectId]);

  // Render the RichTextEditorPage which will detect project mode from localStorage
  return <RichTextEditorPage />;
}
